import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
export const requestCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})

requestCode.definition = {
    methods: ["get","head"],
    url: '/login/two-factor/enroll/{method}/code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
requestCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return requestCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
requestCode.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
requestCode.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: requestCode.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
    const requestCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: requestCode.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
        requestCodeForm.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthEnrollmentController::requestCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:104
 * @route '/login/two-factor/enroll/{method}/code'
 */
        requestCodeForm.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    requestCode.form = requestCodeForm
/**
* @see \App\Http\Controllers\AuthEnrollmentController::verifyCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:162
 * @route '/login/two-factor/enroll/{method}/code'
 */
export const verifyCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

verifyCode.definition = {
    methods: ["post"],
    url: '/login/two-factor/enroll/{method}/code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthEnrollmentController::verifyCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:162
 * @route '/login/two-factor/enroll/{method}/code'
 */
verifyCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return verifyCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthEnrollmentController::verifyCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:162
 * @route '/login/two-factor/enroll/{method}/code'
 */
verifyCode.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthEnrollmentController::verifyCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:162
 * @route '/login/two-factor/enroll/{method}/code'
 */
    const verifyCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verifyCode.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthEnrollmentController::verifyCode
 * @see app/Http/Controllers/AuthEnrollmentController.php:162
 * @route '/login/two-factor/enroll/{method}/code'
 */
        verifyCodeForm.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verifyCode.url(args, options),
            method: 'post',
        })
    
    verifyCode.form = verifyCodeForm
const enroll = {
    requestCode: Object.assign(requestCode, requestCode),
verifyCode: Object.assign(verifyCode, verifyCode),
}

export default enroll